export function formatCurrency(amount: number | null | undefined) {
    if (!amount) {
        return "£ --";
    }

    if (amount < 0) {
        if (amount > -1) {
            return "-" + amount.toFixed(2).split('.')[1] + "p";
        }

        return "-£" + Math.abs(amount).toFixed(2);
    }

    if (amount < 1) {
        return amount.toFixed(2).split('.')[1].replace(/^0+/, '') + "p";
    }

    return "£" + amount.toFixed(2);
}

export function hasPrefixSymbol(value: string) {
    if (value.length > 1) {
        return value[0] === '£';
    }

    return false;
}
